export enum PortfolioSelectionRequirements {
    /*
     * The widget is not dependent on the Portfolio
     */
    None,
    /*
     * Exactly one order is streamed (when in Newport) or selected
     */
    ExactlyOneOrder,
    /*
     * At least one order is streamed (when in Newport) or selected
     */
    AtLeastOneOrder, // Expertise, Strategy Params
    /*
     * At least one order is streamed (when in Newport) or selected, and if multiple are for one position
     */
    PositionFromAtLeastOneOrder, // Fills Graph, Open Submissions
    SymbolFromAtLeastOneOrder, // Venue Analysis
    SingleSymbolQuantity, // Liquidity Summary
    AtLeastOneSymbolQuantity, // Intraday Profiles
    SingleSymbol, // Symbol Info
    Portfolio, // Portfolio Summary, Portfolio Returns
    PortfolioOfOrders, // Outliers
}
